import pick from 'ramda/src/pick'
import omit from 'ramda/src/omit'
import into from 'ramda/src/into'
import map from 'ramda/src/map'
import compose from 'ramda/src/compose'
import evolve from 'ramda/src/evolve'
import assoc from 'ramda/src/assoc'
import cond from 'ramda/src/cond'
import T from 'ramda/src/T'
import equals from 'ramda/src/equals'
import identity from 'ramda/src/identity'

import { renameKeys, parseFinancial, momentFormatter } from '../../../lib/utils'

/**
 * @typedef {'' | '-' | number} ValueState
 * 
 * @typedef {object} SummaryTimesheetReport
 * @property {string} date
 * @property {string} employee_id
 * @property {string} employee_name
 * @property {string} lob_name
 * @property {string} project_code
 * @property {string} location_name
 * @property {string} task
 * @property {string} approver_name
 * @property {string} status
 * @property {string} remark
 */

/** map from a report api response to local fields */
const SUMMARY_TIMESHEET_REPORT_MAPPER = {
  date: 'date',
  employee_id: 'employee_id',
  employee_name: 'employee_name',
  lob_name: 'lob_name',
  project_code: 'project_code',
  location_name: 'location_name',
  task: 'task',
  approver_name: 'approver_name',
  status: 'status',
  remark: 'remark'
}

/** @type {(x: string) => ValueState} */
export const toValueState = cond([
  [equals(''), identity],
  [equals('-'), identity],
  [T, parseFinancial],
])

// prettier-ignore
/** @type {(json: object) => SummaryTimesheetReport[]} */
export const toTimesheets = json => into([], compose(
  map(pick(Object.keys(SUMMARY_TIMESHEET_REPORT_MAPPER))),
  map(renameKeys(SUMMARY_TIMESHEET_REPORT_MAPPER)),
), json.report)



// WEBPACK FOOTER //
// ./src/pages/report/summary-timesheet/model.js